export default {
  nameRules: [(name) => !!name || 'required'],
  phoneRules: [(phoneNumber) => /^$|\(\d{3}\)\s\d{3}-\d{4}$/.test(phoneNumber) || 'Invalid phone number'],
  emailRules: [(email) => !!email || 'E-mail is required', (email) => /^\S+@\S+\.\S+$/.test(email) || 'E-mail must be valid'],
}
